import { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Permission, PermissionType } from '../api/interfaces'
import { useGetOrganizationQuery } from '../api/rtkQueryApi/platform/organizationsApi'
import { RootState } from '../app/rootReducer'
import { OrganizationPermissionsContext } from './OrganizationPermissionsContext'

export const OrganizationPermissionsProvider: FC<PropsWithChildren<any>> = props => {
  const [permissions, setPermissions] = useState<Permission[]>([])
  const { isLoggedIn } = useSelector((state: RootState) => state.app)
  const organizationQuery = useGetOrganizationQuery(undefined, { skip: !isLoggedIn })

  useEffect(() => {
    setPermissions(organizationQuery.data?.permissions ?? [])
  }, [organizationQuery.data])

  const hasPermission = useCallback(
    (permissionType: PermissionType) => {
      return permissions.some(permission => permission.permissionType === permissionType)
    },
    [permissions]
  )

  return <OrganizationPermissionsContext.Provider value={{ permissions, hasPermission }}>{props.children}</OrganizationPermissionsContext.Provider>
}
